'use client';

import { c as _c } from "react/compiler-runtime";
import { useEffect, useRef } from 'react';

/**
 * Vuukle Widgets — comments, in its own iframe for isolation
 * (Vuukle hardcodes element IDs, so multiple instances need separate DOMs).
 *
 * Extracted verbatim from src/app/api/articles/ArticleListInfinite.tsx so both
 * the legacy per-story-template renderer and the dynamic article-template
 * renderer (ArticleComments component type) mount the identical widget.
 */
export interface VuukleCommentsProps {
  articleId: string;
  articleTitle: string;
  articleUrl: string;
  articleImage: string;
  articleTags: string;
  articleAuthor: string;
  /** Builder-authored note shown above the comment box, e.g. a moderation/
   *  views notice ("The views expressed in the comments below are those of
   *  the users..."). Unset/empty renders nothing — matches every other
   *  Builder-authored text field's "hide, don't show placeholder" behavior. */
  disclaimer?: string;
}
export default function VuukleComments(t0) {
  const $ = _c(18);
  const {
    articleId,
    articleTitle,
    articleUrl,
    articleImage,
    articleTags,
    articleAuthor,
    disclaimer
  } = t0;
  const iframeRef = useRef(null);
  let t1;
  if ($[0] !== articleAuthor || $[1] !== articleId || $[2] !== articleImage || $[3] !== articleTags || $[4] !== articleTitle || $[5] !== articleUrl) {
    t1 = JSON.stringify({
      apiKey: "6f27340a-c671-45a9-ae0c-13b8d5595b42",
      host: "dinamani.com",
      articleId,
      img: articleImage,
      tags: articleTags,
      url: articleUrl,
      title: articleTitle,
      author: articleAuthor,
      language: "en",
      comments: {
        transliteration: {
          language: "ta",
          enabledByDefault: false
        }
      }
    });
    $[0] = articleAuthor;
    $[1] = articleId;
    $[2] = articleImage;
    $[3] = articleTags;
    $[4] = articleTitle;
    $[5] = articleUrl;
    $[6] = t1;
  } else {
    t1 = $[6];
  }
  const vuukleConfig = t1;
  const iframeId = `vuukle-${articleId}`;
  const srcDoc = `<!DOCTYPE html><html><head><style>body{margin:0;padding:0;}#vuukle-comments{overflow:hidden;}.vuukle-powered-by,.vuukle-privacy,.vuukle-footer,div[class*="powered"],div[class*="privacy"]{margin-bottom:0!important;padding-bottom:0!important;}body>div:last-child{margin-bottom:0!important;padding-bottom:0!important;}</style></head><body><div id="vuukle-comments"></div><script>var VUUKLE_CONFIG=${vuukleConfig};<\/script><script src="https://cdn.vuukle.com/platform.js" async><\/script><script>(function(){var observer=new ResizeObserver(function(){var height=document.body.scrollHeight;window.parent.postMessage({type:'vuukle-resize',id:'${iframeId}',height:Math.max(height,50)},'*');});observer.observe(document.body);})();<\/script></body></html>`;
  let t2;
  let t3;
  if ($[7] !== iframeId) {
    t2 = () => {
      let appliedHeight = 800;
      const handler = e => {
        if (e.data?.type === "vuukle-resize" && e.data?.id === iframeId && e.data?.height) {
          const iframe = iframeRef.current;
          if (!iframe) {
            return;
          }
          const newHeight = Number(e.data.height) || 0;
          if (newHeight > appliedHeight + 60) {
            appliedHeight = newHeight;
            iframe.style.height = `${newHeight}px`;
          }
        }
      };
      window.addEventListener("message", handler);
      return () => window.removeEventListener("message", handler);
    };
    t3 = [iframeId];
    $[7] = iframeId;
    $[8] = t2;
    $[9] = t3;
  } else {
    t2 = $[8];
    t3 = $[9];
  }
  useEffect(t2, t3);
  let t4;
  if ($[10] !== disclaimer) {
    t4 = disclaimer && <p className="text-12-tamil-400 text-808080 px-3 pt-3">{disclaimer}</p>;
    $[10] = disclaimer;
    $[11] = t4;
  } else {
    t4 = $[11];
  }
  let t5;
  if ($[12] === Symbol.for("react.memo_cache_sentinel")) {
    t5 = {
      height: "800px"
    };
    $[12] = t5;
  } else {
    t5 = $[12];
  }
  let t6;
  if ($[13] !== srcDoc) {
    t6 = <iframe ref={iframeRef} srcDoc={srcDoc} className="w-full border-0" style={t5} title="Vuukle Widgets" />;
    $[13] = srcDoc;
    $[14] = t6;
  } else {
    t6 = $[14];
  }
  let t7;
  if ($[15] !== t4 || $[16] !== t6) {
    t7 = <>{t4}{t6}</>;
    $[15] = t4;
    $[16] = t6;
    $[17] = t7;
  } else {
    t7 = $[17];
  }
  return t7;
}